// import { EJSON } from "bson";
import { CustomPipelineFactory } from '@/providers/dataProvider';

import { remoteCustomFetcher } from '@/providers/backendClient';
import { addDays, startOfDay, startOfWeek } from 'date-fns';

export const sessionNotesCustomFetcher: CustomPipelineFactory =
  async ({ sort, filter, page, perPage }) => {
    const result = await remoteCustomFetcher(
      'therapistSessionNotes',
      {
        sort,
        filter,
        page,
        perPage,
      },
    );

    return result;
  };

const dataCleaningStage = {
  $addFields: {
    narrative: {
      $binarySize: '$narrative',
    },
    transcript: {
      $binarySize: '$transcript',
    },
    title: {
      $binarySize: '$title',
    },
    singleSentence: {
      $binarySize: '$singleSentence',
    },
    bullet: {
      $binarySize: '$bullet',
    },
    tags: {
      $binarySize: '$tags',
    },
    grammar: {
      $binarySize: '$grammar',
    },
  },
};

const reportPipeline = [
  {
    $lookup: {
      from: 'therapists',
      localField: 'therapistId',
      foreignField: '_id',
      as: 'therapist',
    },
  },
  {
    $unwind: {
      path: '$therapist',
      preserveNullAndEmptyArrays: true,
    },
  },
  {
    $sort: {
      _id: -1,
    },
  },
  {
    $addFields: {
      therapistFirstName: '$therapist.firstName',
      therapistLastName: '$therapist.lastName',
      therapistTitle: '$therapist.title',
      therapistEmail: '$therapist.email',
    },
  },
  {
    $project: {
      therapist: 0,
    },
  },
];

export type DatePreset = {
  id: string;
  name: string;
  filter: () => {
    createdAtGte?: Date | null;
    createdAtLte?: Date | null;
  };
};

export const datePresets: DatePreset[] = [
  {
    id: 'today',
    name: 'Today',
    filter: () => ({
      createdAtGte: startOfDay(new Date()),
    }),
  },
  {
    id: 'yesterday',
    name: 'Yesterday',
    filter: () => {
      const yesterday = startOfDay(addDays(new Date(), -1));

      return {
        createdAtGte: yesterday,
        createdAtLte: addDays(yesterday, 1),
      };
    },
  },
  {
    id: 'currentWeek',
    name: 'Current Week',
    filter: () => ({
      createdAtGte: startOfWeek(new Date(), { weekStartsOn: 1 }),
    }),
  },
  {
    id: 'last7days',
    name: 'Last 7 Days',
    filter: () => ({
      createdAtGte: addDays(new Date(), -7),
    }),
  },
  {
    id: 'lastWeek',
    name: 'Previous Week',
    filter: () => {
      const sevenDaysAgo = addDays(new Date(), -7);
      const lastWeek = startOfWeek(sevenDaysAgo, { weekStartsOn: 0 });

      return {
        createdAtGte: lastWeek,
        createdAtLte: addDays(lastWeek, 7),
      };
    },
  },
  {
    id: 'last30days',
    name: 'Last 30 Days',
    filter: () => ({
      createdAtGte: addDays(new Date(), -30),
    }),
  },
];

export const datePresetsMap = new Map(
  datePresets.map(preset => [preset.id, preset]),
);
